import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { INITIAL_STATE } from "constants/initialState";
import reducer from "./slices";

// Export in order to access in spaceMedia
export const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      // // Ignore these action types
      ignoredActions: ["auth/setCurrentUser", "homeStart/setRootIcon"],
      // Ignore these field paths in all actions
      ignoredActionPaths: ["auth"],
      // Ignore these paths in the state
      ignoredPaths: ["auth", "createPicture", "homeStart"],
    },
    immutableCheck: {
      ignoredPaths: ["devices", "auth", "socket"],
    },
  }),
  devTools:
    process.env.NODE_ENV !== "production" ||
    process.env.REACT_APP_EFS_DEBUG === "true",
  preloadedState:
    process.env.NODE_ENV === "development" && false ? INITIAL_STATE : {},
});
